// User account constants (Users pages and the user page). Add new user-related values here.

// Where an account's scheduled deletion came from (inactive_users.delete_source, the API's RequestSourceEnum).
// Only MANUAL (asked for by the user or an admin) can be cancelled: the API cancels as that source.
export const DELETE_SOURCE = {
  GDPR: 'command',
  MANUAL: 'manual_command',
  ADMIN_FORCE: 'admin_force'
}

// How each source shows in the Users Up for Deletion list and on the user page.
export const DELETE_SOURCE_DISPLAY = {
  [DELETE_SOURCE.GDPR]: { text: 'GDPR Automatic Deletion', color: 'danger' },
  [DELETE_SOURCE.MANUAL]: { text: 'User/Admin Initiated', color: 'accent-color' },
  [DELETE_SOURCE.ADMIN_FORCE]: { text: 'MySQL Force Deletion', color: 'danger' }
}
